import React from 'react';
import { FaPlus } from 'react-icons/fa';
import { Link, To } from 'react-router-dom';

type CreateButtonProps = {
  label?: string;
  path?: To;
};

interface CreateButtonModalProps extends Omit<CreateButtonProps, 'path'> {}

export const CreateButton: React.FC<CreateButtonProps> = ({ label, path }) => {
  return (
    <Link
      className="flex flex-row items-center gap-2 px-3 py-2 transition-all bg-green-400 rounded-md shadow-md hover:bg-green-500"
      to={path ?? 'create'}
    >
      <FaPlus size={15} className="text-white" />

      {label && (
        <span className="text-sm font-semibold text-white">{label}</span>
      )}
    </Link>
  );
};

export const CreateButtonModal: React.FC<CreateButtonModalProps> = ({
  label,
}) => {
  return (
    <button
      type="button"
      className="flex flex-row items-center gap-2 px-3 py-2 transition-all bg-green-400 rounded-md shadow-md hover:bg-green-500"
    >
      <FaPlus size={15} className="text-white" />

      {label && (
        <span className="text-sm font-semibold text-white">{label}</span>
      )}
    </button>
  );
};
